import { callApi } from "./index"

export const fetchSearch = (searchTerm: string, categorySlug: string | undefined, includeInactiveSuppliers: boolean = false): Promise<SearchResultType[]> => {
  return callApi("/api/EasyDirectoryAPI/SearchSuppliers", { 
    searchTerm: searchTerm, 
    categorySlug: categorySlug === undefined ? '' : categorySlug,
    includeOffline: includeInactiveSuppliers
  })
}

export interface SearchResultType {
  Id: number;
  Name: string;
  AverageRating: number;
  ReviewCount: number;
  ImageUrl: string;
  Slug: string;
  CategorySlug: string;
  CategoryName: string;
  RegionSlug: string;
  Region: string;
  Url: string;
  DirectoryCategory: string;
  Thumbnail: string;
  SupplierCity: string;
  SupplierState: string;
}
